import './compliances.scss'

import { Card, Tabs, Typography } from 'antd'
import React, { useState } from 'react'
import { Column } from 'react-display-flex'

import { SelectTenant } from '../../../components'
import { IssuerCompliances } from './IssuerCompliances'
import { MaturityCompliances } from './MaturityCompliances'
import { RatingsCompliances } from './RatingsCompliances'

const { TabPane } = Tabs

export const CompliancesValues = () => {
  const [currentTenant, setCurrentTenant] = useState(null)

  return (
    <Column className="compliances">
      <Typography.Title>Compliance Values</Typography.Title>

      <SelectTenant onTenantSelected={setCurrentTenant} />

      {!currentTenant ? (
        <Card>
          <Typography.Title level={3}>Select a tenant</Typography.Title>
          <Typography>Please select a tenant to check its compliance values</Typography>
        </Card>
      ) : (
        <Tabs defaultActiveKey="ratingsCompliances" type="card">
          <TabPane tab="Ratings Compliances" key="ratingsCompliances">
            <RatingsCompliances tenant={currentTenant} />
          </TabPane>
          <TabPane tab="Maturity Compliances" key="maturityCompliances">
            <MaturityCompliances tenant={currentTenant} />
          </TabPane>
          <TabPane tab="Issuer Compliances" key="issuerCompliances">
            <IssuerCompliances tenant={currentTenant} />
          </TabPane>
        </Tabs>
      )}
    </Column>
  )
}
